import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import throttle from 'lodash/throttle';
import { AuthContext } from '../_auth/AuthContext';
import { ISearchResult } from '../_types/search';
import { SearchUsers } from '../_service/user';
import { IChangeEventHandler } from '../_types/nav';
import { usePromiseTracker } from 'react-promise-tracker';

import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));
  
 
  interface Props {
    onChange: IChangeEventHandler<ISearchResult | null>;
  };
  
  const UserSearch: React.FC<Props> = (prop: Props) => {

    //const classes = useStyles();
    const [value, setValue] = React.useState<ISearchResult | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<ISearchResult[]>([]);


    //const loaded = React.useRef(false);
    const { user } = useContext(AuthContext);
    let abort = new AbortController();

    /** Throttles the SearchLocation Service which calls out to the api to search on users input */
    const fetch = React.useMemo(
      () => 
        throttle((request: { input: string, locationId: number | null }, callback: (results: ISearchResult[] | null) => void) => {

            abort.abort();
            abort = new AbortController();
           SearchUsers(request.input, true, abort, request.locationId).then((res) => callback(res));
          
        }, 3000),
      [],
    );
    

    const changeUser = (newUser: ISearchResult | null) => {
 
      let toFire: ISearchResult | null = null;
      if (newUser) {
        toFire = {...newUser} as ISearchResult;
      } 
      prop.onChange(toFire);
      
      setValue(null);
      setOptions([]);
      setInputValue('');
    };

  
    /** Watches for changes to user input and relays to fetch to execute search */
    React.useEffect(() => {
      let active = true;
  
      if (inputValue === '') {
        setOptions(value ? [value] : []);
        return undefined;
      }


      let locationId: number | null = null;
      if (user.currentLocation)  {
        
        locationId = user.currentLocation.id;

      }
      
      
      
      fetch({ input: inputValue,locationId: locationId}, (results: ISearchResult[] | null) => {
        if (active) {
          let newOptions = [] as ISearchResult[];
  
          if (value) {
            newOptions = [value];
          }
  
          if (results) {
            newOptions = [...newOptions, ...results];
          }
  
          setOptions(newOptions);
        }
      });

      


      
  
      return () => {
        active = false;
      };
    }, [value, inputValue, fetch]);
  
    const _getOption = (option: ISearchResult): any => {

      let matchOn: string = "";
      switch(option.matchOn) {
        case "email": matchOn = "Email Address"; break;
        case "phone": matchOn = "Phone"; break;
        case "plate": matchOn = "License Plate"; break;
        case "last4": matchOn = "CC Last 4"; break;
        case "ppcustomerid": matchOn = "Provider Customer Id"; break;
        case "ppsubscriptionid": matchOn = "Provider Subscriber Id"; break;
        case "membershipuuid": matchOn = "Unique Membership Id"; break;
        case "useruuid": matchOn = "Unique User Id"; break;
        default: matchOn = "Undefined"; break;
      }
      return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch">
          <Grid item><i>{option.name}</i></Grid>
          <Grid item><b>{matchOn}</b>: {option.match}</Grid>
        </Grid>
      )
    }


    return (
        <Autocomplete
          id="google-map-demo"
          size="small"
          style={{ width: 300 }}
          getOptionLabel={(option) => (typeof option === 'string' ? option : option.value)}
          filterOptions={(x) => x}
          options={options}
          autoComplete
          includeInputInList
          filterSelectedOptions
          renderOption={(option) => 
              _getOption(option)
          }
          value={value}
          onChange={(event: any, newValue: ISearchResult | null) => {
            setOptions(newValue ? [newValue, ...options] : options);
            setValue(newValue);
            changeUser(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          renderInput={(params) => (
            <TextField {...params}  variant="outlined" fullWidth />
          )}/>
        );
    

  }
  

  export default UserSearch;